import React, { useEffect, useRef, useState } from "react";
import Recorder from "../../QuestionPage/recorder";
import AudioPlayer from "../../QuestionPage/AudioPlayer";
import ExamPanel from "../ExamPanel";

const DEFAULT_REPEAT_RECORDING_SECONDS = 20;

export default function RepeatSentencePage({
  question,
  onInputChange,
  questionNumber,
  ...props
}) {
  const [text, setText] = useState("");
  const [audioLink, setAudioLink] = useState("");
  const [recorderStartSignal, setRecorderStartSignal] = useState(0);
  const [recordingDuration, setRecordingDuration] = useState(
    DEFAULT_REPEAT_RECORDING_SECONDS
  );
  const audioRef = useRef(null);

  useEffect(() => {
    const fetchSignedUrl = async () => {
      try {
        const res = await fetch(question.media_link);
        const data = await res.json();
        setAudioLink(data.url);
        setRecordingDuration(DEFAULT_REPEAT_RECORDING_SECONDS);
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }
      } catch (err) {
        console.error("Failed to fetch signed audio URL:", err);
      }
    };

    if (question?.media_link) fetchSignedUrl();
  }, [question]);

  const handleTextChange = (newText) => {
    if (newText !== text) {
      setText(newText);
      onInputChange(newText);
    }
  };

  return (
    <ExamPanel
      eyebrow="Speaking"
      title="Repeat Sentence"
      questionLabel={`Question ${questionNumber} of 36`}
      instructions="You will hear a sentence. Repeat the sentence exactly as you hear it. You will hear it only once."
    >
      <div className="grid gap-6 lg:grid-cols-[minmax(280px,1fr),420px] lg:items-start">
        <div className="rounded-md border border-slate-200 bg-slate-50 p-5">
          {audioLink ? (
            <AudioPlayer
              audioSrc={audioLink}
              audioRef={audioRef}
              onDurationChange={(duration) =>
                setRecordingDuration(Math.ceil(duration + 3))
              }
              onEnded={() =>
                setRecorderStartSignal((currentSignal) => currentSignal + 1)
              }
            />
          ) : (
            <p className="text-sm font-semibold text-gray-500">Loading audio...</p>
          )}
        </div>

        <div className="rounded-md border border-slate-200 bg-white p-4">
          <Recorder
            key={`${question?._id || questionNumber}-${recordingDuration}`}
            text={text}
            setText={handleTextChange}
            {...props}
            autoStart={false}
            autoStartSignal={recorderStartSignal}
            waitingLabel="Recording starts after audio"
            duration={recordingDuration}
            className="min-h-56 w-full rounded-md border border-slate-200 bg-slate-50"
          />
        </div>
      </div>
    </ExamPanel>
  );
}
